import {SimpleStat} from './simple-stat';

export class DateStat extends SimpleStat {
  key: string = '';
}
